export default __webpack_public_path__ + "static/media/paymentTutorial_pc_bottom_Cn.4ffe7e3b.webp";